// A MESMA malha para cabeçalho, réguas, linhas e rodapé do ranking: é o que faz o
// rótulo "base" cair exatamente sobre o eixo de cada coluna, em qualquer largura de tela. Uma
// malha por trecho desalinha no primeiro nome de candidato mais longo.
// A coluna do nome é a mais larga (os rótulos do motor são frases, não códigos) e a de OEE é a
// mais estreita: ela descreve, não ranqueia.
export const RANKING_GRID =
  "grid grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)_minmax(0,0.8fr)] gap-x-3";

/** Objetivo que JÁ É o OEE: a segunda faixa seria a primeira de novo. */
export const RANKING_GRID_SINGLE = "grid grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] gap-x-3";
